import React, { useEffect, useState } from "react"
import * as sessions from "sessions"
import * as brands from "brands"
import * as layouts from "layouts"
import styled from "@emotion/styled"
import * as httpx from "httpx"
import * as icons from "icons"
import * as api from "brandguard/api"
import * as predictions from "brandguard/predictions"
import * as bglayouts from "brandguard/components/layouts"
import classnames from "classnames"
import { css } from "@emotion/css"

interface props {
	item: api.DocumentSearchResponseItem
	active?: boolean
	panel: JSX.Element
	onCardClick(): void
	onChecked?(state: boolean): void
	onChange(item: api.DocumentSearchResponseItem): void
	find(id: string, bid: string, ...options: httpx.option[]): Promise<api.DocumentFindResponse>
	documentBackground?: string
	cardClassName?: string
	initialChecked: boolean
}

const Checkbox = styled(icons.brandguard.checkbox)`
	position: absolute;
	top: 7px;
	right: 7px;
`

const DocumentIcon = styled(icons.brandguard.document)`
	width: 100px;
	height: 100px;
	opacity: 0.3;
`

export default function Display(props: React.PropsWithChildren<props>): JSX.Element {
	const {
		item,
		active,
		onChange,
		onCardClick,
		onChecked,
		find,
		panel,
		documentBackground,
		cardClassName,
		initialChecked,
		...rest
	} = props
	const [checked, setChecked] = useState(initialChecked)
	const bearertoken = sessions.useToken()
	const brand = brands.caching.useCached()
	const processing = predictions.processing(item.event?.approved)

	useEffect(() => {
		if (!onChange) return
		if (!processing) return

		let cancelled = false
		const tid = setTimeout(() => {
			find(item.media?.id!, brand.id, bearertoken)
				.then((result) => {
					cancelled || onChange(result)
				})
				.catch((cause) => console.error("unable to display", cause))
		}, Math.round(Math.random() * 5000 + 5000))

		return () => {
			clearTimeout(tid)
			cancelled = true
		}
	}, [item])

	return (
		<bglayouts.Card
			key={item.media?.id}
			className={`${cardClassName} ${active ? "active" : ""}`}
			onClick={onCardClick}
			flexDirection="column"
			{...rest}
		>
			<layouts.containers.flex
				background={documentBackground}
				opacity={processing ? 0.3 : 1}
				height="100%"
				alignItems="center"
				justifyContent="center"
				className={classnames(maxsizefixed, "card-document")}
			>
				<layouts.containers.flex flexDirection="column" alignItems="center">
					<DocumentIcon />
					<layouts.Span fontSize="12px" mt="10px" color={layouts.theme.colors.grey.dark50}>
						{item.event?.page_count || 0} {item.event?.page_count === 1 ? 'page' : 'pages'}
					</layouts.Span>
					<layouts.Span fontSize="10px" color={layouts.theme.colors.grey.dark50}>
						{item.event?.pages_scored || 0} scored
					</layouts.Span>
				</layouts.containers.flex>
			</layouts.containers.flex>
			{onChecked && (
				<Checkbox
					className="card-document-checkbox"
					onClick={(e) => {
						onChecked(!checked)
						setChecked(!checked)
						e.stopPropagation()
					}}
					checked={checked}
				/>
			)}
			{panel}
		</bglayouts.Card>
	)
}

Display.defaultProps = {
	cardClassName: "",
	documentBackground: layouts.theme.colors.grey.lightest,
	initialChecked: false,
}

export const maxsizefixed = css`
	width: 380px;
	height: 190px;
	margin: 0;
	margin-top: auto;
`
